import { render, staticRenderFns } from "./Signup.vue?vue&type=template&id=13a1f218&scoped=true&"
import script from "./Signup.vue?vue&type=script&lang=js&"
export * from "./Signup.vue?vue&type=script&lang=js&"
import style0 from "@/assets/accounts.css?vue&type=style&index=0&id=13a1f218&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a1f218",
  null
  
)

export default component.exports